import React from 'react';
import GlassSkillsContainer from './GlassSkillsContainer';

function Skills() {
  return (
    <section className="skills" id="skills">
      <h2>Skills</h2>
      <GlassSkillsContainer />
    </section>
  );
}

export default Skills;
